import { ChangeRequestSource, Maybe, ProjectRoleDetail } from "src/generated/graphqlTypes";

export function getRoleOptions(roles: Omit<ProjectRoleDetail, "sortOrder">[]) {
  return roles.map((role) => ({ name: role.name, id: role.code }));
}

export function isPersonalizationChangeSource(source: Maybe<ChangeRequestSource>) {
  return (
    source === ChangeRequestSource.CustomerRequestPersonalization ||
    source === ChangeRequestSource.BoylCustomerRequestPersonalization
  );
}

export function isFeeBuildProjectChangeSource(source: Maybe<ChangeRequestSource>) {
  return source === ChangeRequestSource.FeeBuildProjectChange;
}
